"use strict";

exports.__esModule = true;
exports.Footnotes = exports.Disclaimer = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = require("ramda");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Disclaimer = function Disclaimer(_ref) {
  var disclaimers = _ref.disclaimers;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    flexWrap: "wrap",
    justifyContent: "flex-start",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: "text-light-grey",
    fontSize: 0,
    mb: 1,
    pl: 1
  }, (0, _ramda.map)(function (disclaimer) {
    return disclaimer + " ";
  }, disclaimers)));
};

exports.Disclaimer = Disclaimer;
Disclaimer.propTypes = {
  /** Array of disclaimer strings  */
  disclaimers: (0, _propTypes.arrayOf)(_propTypes.string)
};
var footnotesFont = {
  color: "text-legal-copy",
  fontSize: [0],
  lineHeight: [0],
  mb: [".75em"]
};

var Footnotes = function Footnotes(_ref2) {
  var _ref2$footnotes = _ref2.footnotes,
      footnotes = _ref2$footnotes === void 0 ? [] : _ref2$footnotes;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    as: "ol",
    mx: 0,
    my: 1,
    pl: 2,
    width: 1
  }, (0, _utils.mapIndexed)(function (footnote, index) {
    return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
      key: index,
      m: 0,
      p: 0,
      tag: "li"
    }, footnotesFont), footnote);
  }, footnotes));
};

exports.Footnotes = Footnotes;
Footnotes.propTypes = {
  /** Array of footnotes strings  */
  footnotes: (0, _propTypes.arrayOf)(_propTypes.string)
};
Footnotes.displayName = "Modules.Footnotes";